import { Outlet, useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { FeatureModalProvider } from '@/components/FeatureModals'
import { RoleRestrictionsProvider } from '@/context/RoleRestrictionsContext/RoleRestrictionsContext'
import { getAdminPanelFirstLink } from '@/pages/AdminPanel/utils/constants'
import { useRoleRestrictions } from '@/hooks/permissions/useRoleRestrictions'
import { useFeatureFlags } from '@/optimizely/useFeatureFlags'
import { FeatureFlag } from '@/optimizely/types'
import { usePaymentReturnHandler } from '@/hooks/usePaymentReturnHandler'
import { RoleRestrictionsModal } from './Modals/RoleRestrictionsModal'
import GetStreamChatDrawer from './GetStreamChat/GetStreamChatDrawer'
import { AssistantProvider } from './Assistant/AssistantProvider'
import AssistantDock from './Assistant/AssistantDock'

const RootLayoutContent = () => {
  const navigate = useNavigate()
  const {
    modalOpen,
    closeModal,
    isLoading,
    hasError,
    errorMessage,
    refetch,
    isRestrictedUser,
  } = useRoleRestrictions()
  const featureFlags = useFeatureFlags()
  const isChatV2 = featureFlags[FeatureFlag.MARKETPLACE_CHAT_V2]
  const isAssistantEnabled = featureFlags[FeatureFlag.ASSISTANT_ENABLED]
  usePaymentReturnHandler()

  const content = (
    <Box className="root_layout">
      {!isChatV2 && <GetStreamChatDrawer />}
      <Outlet />
      <RoleRestrictionsModal
        open={modalOpen}
        onClose={closeModal}
        onAddAttorneys={() => {
          closeModal()
          navigate(getAdminPanelFirstLink())
        }}
        hasError={hasError}
        errorMessage={errorMessage}
        isLoading={isLoading}
        onRetry={refetch}
        isRestrictedUser={isRestrictedUser}
      />
      {isAssistantEnabled && <AssistantDock />}
    </Box>
  )

  // Ask Attorney Share: flag off renders the layout exactly as before.
  if (!isAssistantEnabled) return content
  return <AssistantProvider>{content}</AssistantProvider>
}

const RootLayout = () => (
  <FeatureModalProvider>
    <RoleRestrictionsProvider>
      <RootLayoutContent />
    </RoleRestrictionsProvider>
  </FeatureModalProvider>
)

export default RootLayout
